<template>
  <div>
    <div class="d-flex align-center">
      <v-btn 
        @click="$router.push('/gsa/new')"
        color="green" 
        dark 
        class="mr-4"
      >
        <v-icon small>mdi-flash</v-icon>
        Добавить GSA
      </v-btn>
      <v-switch
        color="green"
        label="Показать удаленные"
        v-model="show_deleted"
      ></v-switch>
      <v-spacer></v-spacer>
      
    </div>
    <div class="d-flex align-center">
      <Autocomplete 
        prepend-icon="mdi-filter"
        class="mr-5"
        label="Дилер"
        v-model="dealer_filter"
        :items="dealer_items"
        :disabled="dealer_items.length <= 1"
        :clearable="(dealer_items.length > 1) && (dealer_filter > 0)"
      />
      <Autocomplete 
        prepend-icon="mdi-filter"
        class="mr-5"
        label="Объект"
        v-model="object_filter"
        :items="object_items"
        :disabled="object_items.length <= 1"
        :clearable="(object_items.length > 1) && (object_filter > 0)"
      />
      <v-text-field
        v-model="search"
        color="green"
        label="Поиск"
        prepend-inner-icon="mdi-magnify"
        append-outer-icon="mdi-close"
        @click:append-outer="search=''"
        
      ></v-text-field>
    </div>
    
    <v-data-table
      :item-class="(el) => el.deleted ? 'hover-master red lighten-2' : 'hover-master'"
      no-data-text="Нет данных"
      no-results-text="Поиск не дал результатов"
      :items-per-page="50"
      search="paceholder"
      color="green"
      :headers="headers"
      :items="linked_items"
      @click:row="dblclick_edit"
      :custom-filter="custom_filter"
      disable-pagination
      hide-default-footer
    >
      <template #item.status="{ item }">
        <div class="d-flex justify-center alignt-center">
          <StatusDip :status="item.status" :version="item.version" />
        </div>
      </template>
      <template #item.actions="{ item }">
        <div class="hover-slave d-flex">        
          <v-btn
            class="mr-2"
            title="Редактировать"
            icon
            @click.stop="edit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn
            title="Удалить"
            icon
            v-if="!item.deleted"
            @click.stop="ask_delete(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <v-btn
            v-else
            title="Восстановить"
            icon
            @click.stop="ask_restore(item)"
          >
            <v-icon>mdi-backup-restore</v-icon>
          </v-btn>
        </div>
        
        
        <!-- {{item}} -->
      </template>
    </v-data-table>
    <Approvement ref="approver" />
  </div>
</template>

<script>
import StatusDip from './ui/StatusDip.vue'
import Approvement from './ui/Approvement.vue'
import Autocomplete from './ui/Autocomplete.vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    search: '',
    show_deleted: false,
    dblclick_item: undefined,
    dealer_filter: undefined,
    object_filter: undefined
  }),
  props: ['gsa_list'],
  methods:{
    custom_filter(value, search, item){
      // console.log(value, search, item)
      if (item.deleted & !this.show_deleted){
        return false
      }

      if (this.dealer_filter > 0) {
        if (item.dealer_id != this.dealer_filter){
          return false
        }
      }

      if (this.object_filter > 0){
        if (item.object_id != this.object_filter) {
          return false
        }
      }

      if (this.search){
        if (
          item.comment.includes(this.search) ||
          item.dealer.includes(this.search) ||
          item.object.includes(this.search) ||
          item.master.includes(this.search) ||
          item.guid == this.search ||
          (''+item.id).includes(this.search)
        ) {
          return true
        } else {
          return false
        }
      }
      
      return true
    },
    async ask_delete(gsa){
      let r = await this.$refs.approver.ask(
        `Вы действительно хотите удалить GSA "${gsa.comment}"?`,
        'удалить',
        'mdi-delete'
      )

      if (r) {
        await this.$store.dispatch('delete_gsa', gsa.id)
      }
    },
    async ask_restore(gsa){
      let r = await this.$refs.approver.ask(
        `Вы действительно хотите восстановить GSA "${gsa.comment}"?`,
        'восстановить',
        'mdi-backup-restore'
      )

      if (r) {
        await this.$store.dispatch('restore_gsa', gsa.id)
      }
    },
    dblclick_edit(item){
      if (this.dblclick_item == item) {
        this.edit(item)
        this.dblclick_item = undefined
      } else {
        this.dblclick_item = item
        setTimeout(() => this.dblclick_item = undefined, 300)
      }
    },
    edit(item){
      this.$router.push(`/gsa/${item.id}`)
    }
  },
  watch:{
    dealer_items(val){
      if (val.length == 1) {
        this.dealer_filter = val[0].value
      } else {
        this.dealer_filter = 0
      }
    },
    object_items(val){
      if (val.length == 1) {
        this.object_filter = val[0].value
      } else {
        this.object_filter = 0
      }
    }
  },
  computed:{
    ...mapGetters(['dealer', 'master', 'object', 'dealers', 'objects']),
    search_object(){
      return {
        search: this.search,
        show_deleted: this.show_deleted,
        dealer_filter: this.dealer_filter,
        object_filter: this.object_filter
      }
    },
    dealer_items(){
      let list = this.dealers.map( el => {
        return {
          text: `(${el.id}) ${el.name}`,
          value: el.id
        }
      })

      if (list.length > 1) {
        list = [{
          text: "Все",
          value: 0
        }].concat(list)
      } 

      return list
    },
    object_items(){

      let list = this.objects

      if (this.dealer_filter > 0){
        list = list.filter( el => el.dealerId == this.dealer_filter)      
      }

      list = list.map( el => {
        return {
          text: `(${el.id}) ${el.objectName}`,
          value: el.id
        }
      })

      if (list.length > 1) {
        list = [{
          text: "Все",
          value: 0
        }].concat(list)
      } 


      return list
    },
    linked_items(){
      return this.gsa_list.map( el => ({
        ...el,
        object: this.master(el.master_id)?.objectName,
        dealer: this.master(el.master_id)?.dealerName,
        master: this.master(el.master_id)?.moduleName
      }))
    },
    // items(){
    //   return this.gsa_list
    //   if (this.show_deleted) {
    //     return this.gsa_list
    //   } else {
    //     return this.gsa_list.filter(el => !el.deleted)
    //   }
    // },
    headers(){
      return [
      {
        text: "#",
        value: 'id'
      },
      {
        text: "Статус",
        value: 'status',
        align: 'center',
        sortable: false
      },
      {
        text: "Название",
        value: 'comment'
      },
      {
        text: "Дилер",
        value: 'dealer'
      },
      {
        text: "Объект",
        value: 'object'
      },
      {
        text: "Мастер-лицензия",
        value: 'master'
      },
      {
        text: "GUID",
        value: 'guid'
      },
      {
        text: "Действия",
        value: 'actions'
      }
    ]}
  },
  mounted(){
    this.dealer_filter = this.dealer_items[0].value
    this.object_filter = this.object_items[0].value
  },
  components:{
    StatusDip,
    Approvement,
    Autocomplete
  }
}
</script>

<style>
.hover-master {
  cursor: pointer;
}
</style>

<style scoped>

.hover-slave {
  opacity: 0;
  transition: opacity .2s ease-in-out;
}

.hover-master:hover .hover-slave {
  opacity: 1;
}
</style>